import React from "react";
import {
    AccountingReportCycle,
    AccountingReportCycleTotal,
} from "@common/constants";
import {
    AccountingReportType,
    ACCOUNTING_REPORT_LABELS,
    ACCOUNTING_REPORT_COMPARISON_OPTIONS,
} from "@common/types/reports/report-type";
import {
    ReportPackageReportSetting,
    REPORT_PACKAGE_CYCLE_SUPPORTED,
} from "@common/types/reports/report-package";
import { Checkbox } from "@design-system/Checkbox/Checkbox";
import { AccountingReportCycleSelect } from "../AccountingReportCycleSelect";
import { AccountingReportComparisonSelect } from "../AccountingReportComparisonSelect";
import styles from "./ReportPackageModal.module.scss";

interface ReportPackageReportRowProps {
    type: AccountingReportType;
    isSelected: boolean;
    setting: ReportPackageReportSetting | undefined;
    onToggle: (type: AccountingReportType) => void;
    onUpdateSetting: (
        type: AccountingReportType,
        update: Partial<ReportPackageReportSetting>,
    ) => void;
}

export const ReportPackageReportRow: React.FC<ReportPackageReportRowProps> = ({
    type,
    isSelected,
    setting,
    onToggle,
    onUpdateSetting,
}) => {
    const hasCycleSupport = REPORT_PACKAGE_CYCLE_SUPPORTED.has(type);
    const comparisonOptions = ACCOUNTING_REPORT_COMPARISON_OPTIONS[type];

    return (
        <div className={styles.reportRow} onClick={() => onToggle(type)}>
            <span
                className={styles.reportCheckbox}
                onClick={(event) => event.stopPropagation()}
            >
                <Checkbox
                    checked={isSelected}
                    onCheckedChange={() => onToggle(type)}
                />
            </span>
            <span className={styles.reportName}>
                {ACCOUNTING_REPORT_LABELS[type]}
            </span>

            <div
                className={styles.reportSelects}
                onClick={(e) => e.stopPropagation()}
            >
                {hasCycleSupport && (
                    <AccountingReportCycleSelect
                        value={
                            setting?.cycle ?? AccountingReportCycleTotal.TOTAL
                        }
                        onChange={(v) =>
                            onUpdateSetting(type, {
                                cycle:
                                    v === AccountingReportCycleTotal.TOTAL
                                        ? undefined
                                        : (v as AccountingReportCycle),
                            })
                        }
                        disabled={!isSelected}
                        className={styles.reportSelectTrigger}
                    />
                )}

                {comparisonOptions.comparisons.length > 0 && (
                    <AccountingReportComparisonSelect
                        comparisons={setting?.comparisons ?? []}
                        comparisonDiffs={setting?.comparisonDiffs ?? []}
                        ratioTypes={setting?.ratioTypes ?? []}
                        availableOptions={comparisonOptions}
                        onChange={(value) => onUpdateSetting(type, value)}
                        disabled={!isSelected}
                        className={styles.reportSelectTrigger}
                    />
                )}
            </div>
        </div>
    );
};
